/**
 * @flow
 * @relayHash 992c431f3ab1218564e58efe26e89a72
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type JobRequestAdminQueryResponse = {|
  +request: ?{| |};
|};
*/


/*
query JobRequestAdminQuery(
  $nodeId: ID!
  $jobOfferStatus: JobOfferStatus
) {
  request: node(id: $nodeId) {
    __typename
    ...JobRequest_request
    id
  }
}

fragment JobRequest_request on JobRequest {
  id
  ...JobRequestHeader_request
  student {
    fullname
    id
  }
  ...JobRequestOffers_request
}

fragment JobRequestHeader_request on JobRequest {
  status
  requestType
  student {
    firstname
    lastname
    profilePictureThumbnailUri
    id
  }
  grade {
    name
    id
  }
  subject {
    name
    id
  }
  totalRateStudent
  totalRateTutor
  createdAt
  openJobOffersCount
  sessions {
    timeSlots {
      id
      ...TimeSlot_timeSlot
    }
    id
  }
}

fragment JobRequestOffers_request on JobRequest {
  offers(status: $jobOfferStatus) {
    id
    tutor {
      firstname
      lastname
      profilePictureUri
      rating {
        average
        count
      }
      id
    }
    totalRateStudent
    totalRateTutor
    sessions {
      timeSlot {
        id
        ...TimeSlot_timeSlot
        startDate
        duration {
          hours
          minutes
          id
        }
      }
      id
    }
    createdAt
    status
  }
}

fragment TimeSlot_timeSlot on TimeSlot {
  id
  startDate
  duration {
    hours
    minutes
    id
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "nodeId",
        "type": "ID!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "jobOfferStatus",
        "type": "JobOfferStatus",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobRequestAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "request",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "nodeId",
            "type": "ID!"
          }
        ],
        "concreteType": null,
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "JobRequest_request",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "JobRequestAdminQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "nodeId",
        "type": "ID!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "jobOfferStatus",
        "type": "JobOfferStatus",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "JobRequestAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "request",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "nodeId",
            "type": "ID!"
          }
        ],
        "concreteType": null,
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "type": "JobRequest",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "status",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalRateStudent",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Student",
                "name": "student",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "firstname",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "lastname",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "profilePictureThumbnailUri",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "fullname",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Grade",
                "name": "grade",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Subject",
                "name": "subject",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "requestType",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalRateTutor",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "createdAt",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "openJobOffersCount",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "JobRequestSession",
                "name": "sessions",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSlot",
                    "name": "timeSlots",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "TimeSlot",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "startDate",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Duration",
                            "name": "duration",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "hours",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "minutes",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "jobOfferStatus",
                    "type": "JobOfferStatus"
                  }
                ],
                "concreteType": "JobOffer",
                "name": "offers",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Tutor",
                    "name": "tutor",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "firstname",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "lastname",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "profilePictureUri",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "OverallRating",
                        "name": "rating",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "average",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "count",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalRateStudent",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalRateTutor",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "JobOfferSession",
                    "name": "sessions",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSlot",
                        "name": "timeSlot",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "startDate",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Duration",
                            "name": "duration",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "hours",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "minutes",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "status",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query JobRequestAdminQuery(\n  $nodeId: ID!\n  $jobOfferStatus: JobOfferStatus\n) {\n  request: node(id: $nodeId) {\n    __typename\n    ...JobRequest_request\n    id\n  }\n}\n\nfragment JobRequest_request on JobRequest {\n  id\n  ...JobRequestHeader_request\n  student {\n    fullname\n    id\n  }\n  ...JobRequestOffers_request\n}\n\nfragment JobRequestHeader_request on JobRequest {\n  status\n  requestType\n  student {\n    firstname\n    lastname\n    profilePictureThumbnailUri\n    id\n  }\n  grade {\n    name\n    id\n  }\n  subject {\n    name\n    id\n  }\n  totalRateStudent\n  totalRateTutor\n  createdAt\n  openJobOffersCount\n  sessions {\n    timeSlots {\n      id\n      ...TimeSlot_timeSlot\n    }\n    id\n  }\n}\n\nfragment JobRequestOffers_request on JobRequest {\n  offers(status: $jobOfferStatus) {\n    id\n    tutor {\n      firstname\n      lastname\n      profilePictureUri\n      rating {\n        average\n        count\n      }\n      id\n    }\n    totalRateStudent\n    totalRateTutor\n    sessions {\n      timeSlot {\n        id\n        ...TimeSlot_timeSlot\n        startDate\n        duration {\n          hours\n          minutes\n          id\n        }\n      }\n      id\n    }\n    createdAt\n    status\n  }\n}\n\nfragment TimeSlot_timeSlot on TimeSlot {\n  id\n  startDate\n  duration {\n    hours\n    minutes\n    id\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/modules/job/__generated__/JobRequestAdminQuery.graphql.js